import { render, staticRenderFns } from "./KFlex.vue?vue&type=template&id=2b6f1268&scoped=true&"
import script from "./KFlex.vue?vue&type=script&lang=js&"
export * from "./KFlex.vue?vue&type=script&lang=js&"
import style0 from "./KFlex.vue?vue&type=style&index=0&id=2b6f1268&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6f1268",
  null
  
)

export default component.exports